import { render, staticRenderFns } from "./teamAccessBlockEdit.vue?vue&type=template&id=069bceb0&scoped=true&"
import script from "./teamAccessBlockEdit.vue?vue&type=script&lang=js&"
export * from "./teamAccessBlockEdit.vue?vue&type=script&lang=js&"
import style0 from "./teamAccessBlockEdit.vue?vue&type=style&index=0&id=069bceb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069bceb0",
  null
  
)

export default component.exports